<!--
  ========================================================================
  @deprecated - This component is deprecated. Use <app-enhanced-fab> instead.

  This template is preserved for reference only.
  All 13 IQAC forms have been migrated to use <app-enhanced-fab> directly.

  See migration guide in iqac-froms-footer.component.ts
  ========================================================================
-->

<ion-footer class="border-top" *ngIf="bottomSheetOpen$ === false">
  <ion-toolbar>
    <div class="row">
      <div class="col-12 col-md-4"></div>
      <div class="col-12 col-md-4">
        <ion-grid>
          <ion-row>
            <ion-col *ngIf="canSubmit()">
              <button type="button" class="btn btn-outline-success btn-sm btn-block" (click)="sendFormForApproval()">
                <i class="fas fa-share-square"></i> &nbsp; Submit
              </button>
            </ion-col>
            <ion-col *ngIf="canReject()">
              <button type="button" class="btn btn-danger btn-sm btn-block" (click)="rejectForm()">
                <i class="fas fa-backspace"></i>&nbsp; Revert
              </button>
            </ion-col>
            <ion-col *ngIf="canForward()">
              <button type="button" class="btn btn-info btn-sm btn-block" (click)="forwordForm()">
                <i class="fas fa-paper-plane"></i> Forward
              </button>
            </ion-col>
            <div class="for-sm-device">
              <ion-col class="for-sm-device">
                <button type="button" class="btn btn-outline-info btn-sm btn-block" (click)="replicateForm()"
                  *ngIf="canReplicate()">
                  <i class="fas fa-copy"></i>&nbsp; Replicate
                </button>
              </ion-col>
            </div>
            <ion-col></ion-col>
            <ion-col>
              <button type="button" class="btn btn-info btn-sm btn-block" (click)="submitForm()" *ngIf="canCreate()">
                <i class="fas fa-paper-plane"></i>&nbsp; Create
              </button>
              <button type="button" class="btn btn-info btn-sm btn-block" (click)="updateForm()" *ngIf="canUpdate()">
                <i class="fas fa-paper-plane"></i>&nbsp; Save
              </button>
              <button type="button" class="btn btn-success btn-sm btn-block" (click)="approvedForm()"
                *ngIf="canAprove()">
                <i class="fas fa-check-circle"></i>&nbsp; Approve
              </button>
              <button type="button" class="btn btn-info btn-sm btn-block" (click)="submitForApprovalWebC()"
                *ngIf="canSubmitByWebc()">
                <i class="fas fa-paper-plane"></i>&nbsp; Submit
              </button>
            </ion-col>
            <ion-col *ngIf="canDeleteForm()">
              <button type="button" class="btn btn-outline-danger btn-sm btn-block" (click)="deleteForm()">
                <i class="fas fa-trash"></i>&nbsp; Delete
              </button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="col-12"></div>
    </div>

  </ion-toolbar>
</ion-footer>
